import { render, staticRenderFns } from "./GroupSideModal.vue?vue&type=template&id=b68adabe&scoped=true&"
import script from "./GroupSideModal.vue?vue&type=script&lang=ts&"
export * from "./GroupSideModal.vue?vue&type=script&lang=ts&"
import style0 from "./GroupSideModal.vue?vue&type=style&index=0&id=b68adabe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68adabe",
  null
  
)

export default component.exports